import { useEffect, useRef, useState } from 'react'
import { Timer } from '../types/timer'

interface UseCountdown extends Timer {
    resetTimer: (time?: number) => void
}

interface UseCountdownProps {
    timeLeft: number
    enabled?: boolean
}
export const useCountdown = ({
    timeLeft,
    enabled = true,
}: UseCountdownProps): UseCountdown => {
    const { current: timeNow } = useRef(new Date().getTime())
    const stopTime = timeNow + timeLeft
    const [countDown, setCountDown] = useState(stopTime - timeNow)

    const resetTimer = (time?: number) => {
        const timeLeft = time || stopTime - timeNow
        setCountDown(timeLeft)
    }

    useEffect(() => {
        if (countDown <= 0 || !enabled) return
        const interval = setInterval(() => {
            setCountDown(countDown - 1000)
        }, 1000)

        return () => clearInterval(interval)
    }, [countDown, enabled])

    const [seconds, minutes] = getReturnValues(countDown)
    return {
        seconds: preFormat(seconds),
        minutes: preFormat(minutes),
        total: countDown,
        resetTimer,
    }
}

const preFormat = (value: number) => (value < 10 ? `0${value}` : value)

const getReturnValues = (countDown: number) => {
    const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((countDown % (1000 * 60)) / 1000)

    return [seconds, minutes]
}
